import { useState } from 'react'

import { DarkProvider } from '@hivewatch/dark'

import { TourPlanI } from '@/features/floor-plan'

import { DarkCreateTourPlan } from './DarkCreateTourPlan'
import { DarkTourPlanCheckPoints } from './DarkTourPlanCheckPoints'
import { DarkTourPlansList } from './DarkTourPlansList'

enum TourPlansState {
  List,
  CheckPoints,
  Create,
}

export interface DarkTourPlansPanelIProps {
  tourPlans: TourPlanI[]
  facilityId: string
  currentFloorId: string
  isExpanded: boolean
  onToggleExpansion: () => void
  onDeviceItemHoverIn: (deviceIds: string) => void
  onDeviceItemsHoverIn?: (deviceIds: string[]) => void
  onDeviceItemHoverOut: () => void
}

export const DarkTourPlansPanel = ({
  tourPlans,
  facilityId,
  currentFloorId,
  isExpanded,
  onToggleExpansion,
  onDeviceItemHoverIn,
  onDeviceItemsHoverIn,
  onDeviceItemHoverOut,
}: DarkTourPlansPanelIProps) => {
  const [tourPlanId, setTourPlanId] = useState<string>(null)
  const [viewState, setViewState] = useState<TourPlansState>(
    TourPlansState.List
  )

  const handleTourPlan = (id?: string) => {
    setTourPlanId(id)
    setViewState(id ? TourPlansState.CheckPoints : TourPlansState.List)
  }

  const handleUpdateTourPlan = (id: string) => {
    setTourPlanId(id)
  }

  const handleCreateTourPlan = () => {
    setViewState(TourPlansState.Create)
  }

  const handleDeleteTourPlan = () => {
    setViewState(TourPlansState.List)
  }

  return (
    <DarkProvider>
      {viewState === TourPlansState.List && (
        <DarkTourPlansList
          facilityId={facilityId}
          isExpanded={isExpanded}
          onCreateTourPlanClick={handleCreateTourPlan}
          onDeviceItemHoverIn={onDeviceItemsHoverIn}
          onDeviceItemHoverOut={onDeviceItemHoverOut}
          onToggleExpansion={onToggleExpansion}
          onTourPlanClick={handleTourPlan}
          tourPlans={tourPlans}
        />
      )}
      {viewState === TourPlansState.CheckPoints && (
        <DarkTourPlanCheckPoints
          currentFloorId={currentFloorId}
          facilityId={facilityId}
          isExpanded={isExpanded}
          onClose={handleTourPlan}
          onDeleteTourPlan={handleDeleteTourPlan}
          onDeviceItemHoverIn={onDeviceItemHoverIn}
          onToggleExpansion={onToggleExpansion}
          onUpdateTourPlan={handleUpdateTourPlan}
          tourPlanId={tourPlanId}
        />
      )}
      {viewState === TourPlansState.Create && (
        <DarkCreateTourPlan
          currentFloorId={currentFloorId}
          facilityId={facilityId}
          isExpanded={isExpanded}
          onClose={handleTourPlan}
          onToggleExpansion={onToggleExpansion}
        />
      )}
    </DarkProvider>
  )
}
